import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { TipService } from '../../services/tip.service';
import { ToastrService } from 'ngx-toastr';
import { CountrySelectionService } from '../../services/country-selection.service';
import { LoggingService } from '../../services/logging.service';

@Component({
  selector: 'app-submit-a-tip',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './submit-a-tip.component.html',
  styleUrls: ['./submit-a-tip.component.css']
})
export class SubmitATipComponent implements OnInit {
  tipForm!: FormGroup;
  submittedJson: string | null = null;
  selectedCountry: any;

  constructor(
    private fb: FormBuilder,
    private tipService: TipService,
    private toastr: ToastrService,
    private countrySelectionService: CountrySelectionService,
    private loggingService: LoggingService
  ) { }

  ngOnInit(): void {
    this.tipForm = this.fb.group({
      content: ['', Validators.required],
      agree: [false]
    });
    this.countrySelectionService.selectedCountry$.subscribe(country => {
      this.selectedCountry = country;
    });
  }

  onSubmit(): void {
    if (this.tipForm.valid) {
      const formValue = this.tipForm.value;
      const tipData = {
        title: {
          value: "Anonymous"
        },
        field_user_text: {
          value: formValue.content
        },
        field_country: {
          value: this.selectedCountry.id.toString()
        }
      };
      this.tipService.submitTip(tipData)
        .subscribe({
          next: (response) => {
            this.submittedJson = JSON.stringify(response, null, 2);
            this.toastr.success('Tip submitted successfully. It will be visible after admin approval.');
            console.log('Tip Submitted Successfully:', response);
            this.loggingService.logEvent('submit_tip', {
              country: this.selectedCountry.name,
            });
            this.tipForm.reset();
          },
          error: (error) => {
            console.error('Error submitting tip:', error);
            this.toastr.error('Failed to submit tip.');
            this.submittedJson = JSON.stringify(error, null, 2);
          }
        });
    }
  }
}